import { Controller } from "@hotwired/stimulus"

// Persists dismiss for trial (and similar) banners: hidden until 24h elapsed or trial days_remaining changes.
export default class extends Controller {
  static values = {
    workspaceId: Number,
    daysRemaining: Number,
    storageKey: String
  }

  connect() {
    if (this.#shouldStayHidden()) {
      this.element.classList.add("d-none")
      return
    }
    this.boundOnClosed = () => this.#onClosed()
    this.element.addEventListener("closed.bs.alert", this.boundOnClosed)
  }

  disconnect() {
    if (this.boundOnClosed) {
      this.element.removeEventListener("closed.bs.alert", this.boundOnClosed)
    }
  }

  #storageKeyFull() {
    return `lucanto:banner:${this.storageKeyValue}:${this.workspaceIdValue}`
  }

  #shouldStayHidden() {
    try {
      const raw = localStorage.getItem(this.#storageKeyFull())
      if (!raw) return false
      const { at, days } = JSON.parse(raw)
      const dismissedAt = new Date(at).getTime()
      const dayMs = 24 * 60 * 60 * 1000
      const lessThan24h = Date.now() - dismissedAt < dayMs
      const sameDays = Number(days) === this.daysRemainingValue
      return lessThan24h && sameDays
    } catch {
      return false
    }
  }

  #onClosed() {
    const payload = { at: new Date().toISOString(), days: this.daysRemainingValue }
    try {
      localStorage.setItem(this.#storageKeyFull(), JSON.stringify(payload))
    } catch {
      // ignore quota / private mode
    }
  }
}
